<template>
	<div class="order">
		<div class="order-list">
			<div class="order-search">
				<div class="title">我的订单</div>
				<div class="search-box">
					<input placeholder="输入订单号搜索" v-model="keyword" />
					<div class="search" @click="search">搜索</div>
				</div>
			</div>
			<div class="order-tab">
				<Tabs :tabs="tabs" :cur="curIndex" @changeTab="changeTab"></Tabs>
				<div class="btn-union" v-show="curIndex===1" @click="unionPay" >{{ isEditUnionPay ? '确认支付' : '合并支付' }}</div>
			</div>
			<div class="orders" v-if="orderList.length > 0">
				<OrderItem  v-for="(item,index) in orderList" :item="item" :key="index" @checkedItem="checkedItem" :index="index" :isEdit="isEditUnionPay" v-on:refresh="refresh"></OrderItem>
			</div>
			<div v-else>
				<NoOrder></NoOrder>
			</div>
			<Page :current="page" :total="total" :page-size="size" @on-change="changePage" show-total style="margin-top: 20px;" show-sizer @on-page-size-change="changeSize" :page-size-opts="[5, 10, 20]"></Page>
		</div>
	</div>

</template>

<script>
	import Tabs  from "@/components/Tabs.vue";
	import OrderItem  from "@/components/OrderItem.vue";
	import NoOrder from "@/components/NoOrder.vue";

	import { getOrderList } from "@/api"
	export default {
		name: 'Order',
		components: {
			Tabs,
			OrderItem,
			NoOrder,

		},
		data() {
			return {
				isEditUnionPay: false,
				page:  1,
				total: -1,
				size:5,
				orderList: [],
				tabs:[
					{
						index:0,
						title:'全部订单',
						value:'all'
					},
					{
						index:1,
						title:'待付款',
						value:'unpaid'
					},
					// {
					// 	index:2,
					// 	title:'待确认',
					// 	value:'preview_confirm'
					// },
					{
						index:2,
						title:'生产中',
						value:'in_pperation'
					},
					{
						index:3,
						title:'待发货',
						value:'waiting_delivery'
					},
					{
						index:4,
						title:'待收货',
						value:'waiting_confirm'
					},
					{
						index:5,
						title:'待评价',
						value:'complete'
					},
				],
				curIndex:0,
				orderStatus:"all",
				keyword:''

			};
		},
		created() {
			this.getList()
		},
		methods: {
			checkedItem(e) {
				this.orderList[e.index].isChecked = e.isChecked
			},
			unionPay() {
				if (this.isEditUnionPay) {
					let list = this.orderList.filter(i => i.isChecked)
					if (list.length == 0) {
						return
					}
					let order_ids = list.map(i => i.order_id)
					this.$router.push({
						name: 'Paytype',
						query: {id:order_ids.join(',')}
					})
					return
				}
				this.isEditUnionPay = !this.isEditUnionPay

			},
			refresh() {
				this.getList()
			},
			changeTab(index) {
				this.page = 1
				this.curIndex = index
				this.orderStatus = this.tabs[index].value
				this.getList()
			},
			changePage(page) {
				this.page = page
				this.getList()
			},
			changeSize(size) {
				this.page = 1
				this.size = size
				this.getList()
			},
			async getList() {
				let json =  await getOrderList({page: this.page, size: this.size, status: this.orderStatus, keyword: this.keyword})
				this.orderList = json.data.list
				this.total = json.data.count
			},
			search() {
				this.page = 1
				this.getList()
			}
		}
	}
</script>

<style lang="scss" scoped>
	.order-list{
		background: #FFFFFF;
		padding-bottom: 10px;
		.order-search{
			height: 54px;
			display: flex;
			justify-content: space-between;
			align-items: center;
			padding: 0 20px;
			.title{
				font-size: 17px;
				color: #0F114A;
				font-weight: bold;
			}
			.search-box{
				width: 300px;
				height: 34px;
				border: 1px solid #B3B3B3;
				display: flex;
				align-items: center;
				input{
					width: 240px;
					height: 30px;
					border: none;
					padding-left: 10px;

				}
				.search{
					border-left: 1px solid #B3B3B3;
					width: 60px;
					line-height: 34px;
					height: 34px;
					font-size: 15px;
					font-weight: 400;
					color: #676767;
					text-align: center;
					cursor: pointer;
				}
			}
		}
		.orders{
			margin-top: 20px;
			width: 100%;
			padding: 0 20px;
		}
	}
	.order-tab{
		padding: 0 20px;
		position: relative;
	}


	.btn-union {
		position: absolute;
		top: 10px;
		right: 50px;
		width: 80px;
		height: 30px;
		line-height: 30px;
		background: #0F114A;
		border-radius: 0.15625vw;
		text-align: center;
		color: #EDD4AC;
		cursor: pointer;
	}


</style>
